module.exports = __webpack_public_path__ + "img/how-we-work-fastener.09f32cda.png";